import { AxiosAdapter as CoreAxiosAdapter } from '@core/adapters';

export class AxiosAdapter extends CoreAxiosAdapter {}
